import { visibleExceptProd } from './featureVisibility';

/**
 * Single switch for the shipped VLDL Cholesterol marker (`vLDL`), added
 * 2026-10-23.
 *
 * Currently: visible in local dev and on slava, HIDDEN IN PROD.
 *
 * History: closed to prod 2026-10-26 so the deploy carrying the "Which labs are
 * supported?" link carried nothing else; released 2026-10-28; closed AGAIN
 * 2026-10-30 at the user's request, because the VLDL ranges are still being
 * finalized and the sign-up questions had to ship without it.
 *
 * ── What this flag covers ──────────────────────────────────────────────────
 *   - the VLDL bar on Lipid Results, the comparison table, both PDFs and the
 *     AI export, all through the PanelMarker value BloodworkAnalysis blanks
 *   - the VLDL box on Add Test Results, and the cholesterol − HDL − LDL fill
 *     that box gets when a component is blurred (bloodwork-entry.tsx)
 *
 * ── What it does not ───────────────────────────────────────────────────────
 *   - `deriveMissing` in BloodworkDerivation.ts. That module is copied into the
 *     labResults lambda (generated/models), so an env check there would be read
 *     in a Lambda with no REACT_APP_ENV. A value it fills is stored and simply
 *     never shown while this is false.
 *   - the stored value. Blanking happens on the PanelMarker, never on
 *     `Bloodwork`, so a test entered on slava keeps its VLDL when prod saves it.
 *   - `lambdas/uploadPdf/utils.js`, which cannot read this flag. `vLDL` is in
 *     its own `HELD_FROM_PROD` set, so in prod the printed row is offered to
 *     My Markers as before. Keep the two in step: release both in one change.
 *
 * ── Before releasing ───────────────────────────────────────────────────────
 * Finish the ranges. Return `true` here, delete `vLDL` from HELD_FROM_PROD in
 * lambdas/uploadPdf/utils.js and promote that lambda, then decide what happens
 * to the `labcorp-lipid-panel-vldl` prebuilt marker in LabPanelCatalog.ts: once
 * the shipped field is visible, a practitioner who took it has two VLDLs.
 */
export function vldlVisible(): boolean {
  return visibleExceptProd();
}
